import React from "react";
import ReactTooltip, { TooltipProps } from "react-tooltip";
import { v4 as uuidv4 } from "uuid";

interface TooltipDivProps extends TooltipProps {
  children: React.ReactElement;
  tooltipMessage: string | string[] | undefined;
}

export const TooltipDiv: React.FC<TooltipDivProps> = ({
  children,
  tooltipMessage,
  delayShow = 250,
  className = "tooltip",
  place = "right",
  effect = "solid",
  type = "light",
  offset,
  ...props
}): JSX.Element => {
  const id = uuidv4();

  const clonedChild = React.cloneElement(children, {
    ["data-tip"]: true,
    ["data-for"]: id
  });

  return (
    <>
      {clonedChild}
      <ReactTooltip
        delayShow={delayShow}
        id={id}
        className={className}
        place={place}
        effect={effect}
        type={type}
        offset={offset}
        {...props}
      >
        {tooltipMessage}
      </ReactTooltip>
    </>
  );
};
